import { render, staticRenderFns } from "./MatchingStats.vue?vue&type=template&id=291a35fa&"
import script from "./MatchingStats.vue?vue&type=script&lang=js&"
export * from "./MatchingStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports